import { Component, OnInit } from '@angular/core';
import { SettingsEnum } from '../../model/settings.enum';
import { FacadeService } from '../../service-facade/facade.service';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.css']
})
export class MaintenanceBannerComponent implements OnInit {
 isBanner : boolean = true;
 maintenanceBanner : string = '';
 banners : any;

  constructor(private facadeService: FacadeService,) { }

  ngOnInit(): void {
    this.maintenanceBanner = this.facadeService.getStorageItem(SettingsEnum.MaintenanceBanner);
    let bannerData = this.facadeService.getStorageItem(SettingsEnum.MaintenanceBanner);
    if(bannerData) {
      this.banners = bannerData.split('|');
    }

    if (!!bannerData) this.banners = bannerData.split('|');
  }
  closeButton(){
    this.isBanner = false;
  }
}
